import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoacheeMoodDialogState {
	saving: boolean;
}

@Injectable()
export class CoacheeMoodDialogStore extends Store<CoacheeMoodDialogState> {
	constructor() {
		super({}, { name: `ui-mood-rating-dialog-${guid()}` });
	}
}
